import React from 'react'
import { Link } from 'react-router-dom'
import { IoLogoYoutube } from "react-icons/io5";
import { FaSquareXTwitter } from "react-icons/fa6";


function MainFooter() {
  return (
    <>
      {/* Footer Start  */}
      <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-3 mt-2">
              <div className="footer-item d-flex flex-column">
                <div>
                  <Link to="#0" className="logo d-flex align-items-center">
                    <span style={{ paddingLeft: "0px" }}>Fever99</span>
                  </Link>
                </div>
                <p className='text-white'>We are here to serve you and address your healthcare needs. Contact Fever99 today to schedule an appointment or to learn more about our services.</p>
                <div className="d-flex align-items-center icon">
                  <Link className="btn-square btn btn-primary text-white mx-1" to="https://www.facebook.com/fever99Eclinic"><i className="fab fa-facebook-f"></i></Link>
                  <Link className="btn-square btn btn-primary text-white mx-1" to="https://x.com/Fever99com?t=DOnEgcHxrXr3H6zFJk_mVA&s=09"><FaSquareXTwitter /></Link>
                  <Link className="btn-square btn btn-primary text-white mx-1" to="https://www.youtube.com/channel/UCf0lHOQNzev2qn6jSvjAMaA/about"><IoLogoYoutube /></Link>
                  <Link className="btn-square btn btn-primary text-white mx-1" to="https://www.instagram.com/fever99eclinic/"><i className="fab fa-instagram"></i></Link>
                  <Link className="btn-square btn btn-primary text-white mx-1" to="https://www.linkedin.com/search/results/all/?keywords=fever99&origin=GLOBAL_SEARCH_HEADER&sid=UH%3B"><i className="fab fa-linkedin-in"></i></Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mt-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="mb-2">Quick Links</h4>
                <Link to="#"><i className="fas fa-angle-right me-2"></i>Home</Link>
                <Link to="/career"><i className="fas fa-angle-right me-2"></i>Career</Link>
                <Link to="/refuncpolicy"><i className="fas fa-angle-right me-2"></i>Cancellation & Refund Policy</Link>
                <Link to="/terms-condition"><i className="fas fa-angle-right me-2"></i>Terms of service</Link>
                <Link to="/privacy"><i className="fas fa-angle-right me-2"></i>Privacy policy</Link>
                <Link to="/register"><i className="fas fa-angle-right me-2"></i>Join Us</Link>
                <Link to="/faq"><i className="fas fa-angle-right me-2"></i>Frequently</Link>
                <Link to="/delete"><i className="fas fa-angle-right me-2"></i>Delete your Account</Link>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mt-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="mb-2">Our Services</h4>
                <Link to="/home-service/physiotherapy-at-home"><i className="fas fa-angle-right me-2"></i>Physiotherapy</Link>
                <Link to="/home-service/doctor-video-consultation"><i className="fas fa-angle-right me-2"></i>Video Consulttion</Link>
                <Link to="/home-service/24x7-ambulance-on-call"><i className="fas fa-angle-right me-2"></i>Ambulance on call</Link>
                <Link to="/home-service/vaccination-at-home"><i className="fas fa-angle-right me-2"></i>Vaccinations at home</Link>
                <Link to="/home-service/ecg-and-x-ray-at-home"><i className="fas fa-angle-right me-2"></i>ECG and X-Ray at home</Link>
                <Link to="/home-service/healthcare-product-at-home"><i className="fas fa-angle-right me-2"></i>Healthcare Product at Home</Link>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mt-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="mb-2">Contact with us</h4>
                <Link to=""><i className="fa fa-map-marker-alt px-1"></i>Shop No 97, Conscient Habitat Society Market, Sector 78, Faridabad, Haryana-121002, India.</Link>
                <Link to=""><i className="fas fa-envelope px-2"></i>info@fever99.com</Link>
                <Link to=""><i className="fas fa-phone px-1"></i> +91 6262808062</Link>
              </div>
            </div>
          </div>
          <hr />
          <div className="container mt-2" style={{ marginBottom: "-30px" }}>
            <div className="copyright" style={{ textAlign: "center" }}>
              &copy; Copyright{" "}
              <strong>
                <span>Fever99 Healthcare Solutions Pvt Ltd</span>
              </strong>
              . All Rights Reserved</div>
          </div>
        </div >
      </div >
      {/* Footer End  */}
    </>
  )
}

export default MainFooter